<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Edit Subscription'"
      [canGoBack]="true"
      [customBack]="'subscription'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    <tidy-row>
      <tidy-text
        [body]="'Tell your account manager what you need and they will take care of it.'" />
    </tidy-row>

    <tidy-card>
      <tidy-card-button (action)="requestChanges()">
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/svg/create-outline.svg'"
            class="header-size" />
          <tidy-text
            [body]="'Request Changes'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'Change your plan, add-ons, or anything else about your subscription.'" />
        </tidy-row>
      </tidy-card-button>
      <tidy-card-button (action)="cancelSubscription()">
        <tidy-row class="vertical-align-center extra-bottom-padding">
          <tidy-image
            [src]="'assets/svg/close-circle-outline.svg'"
            class="header-size" />
          <tidy-text
            [body]="'Cancel Subscription'" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [helper]="'End your subscription. Cancel anytime — there is no contract.'" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
